import * as React from 'react';
import { joinClassNames } from '@/lib/class-names';
import s from './InventoryCockpit.module.scss';

export type InventoryCockpitProps = React.HTMLAttributes<HTMLDivElement>;

export type InventoryCanvasProps = React.HTMLAttributes<HTMLElement>;

export type InventoryRailProps = React.HTMLAttributes<HTMLElement>;

function Root({ className, ...rest }: InventoryCockpitProps) {
  return <div className={joinClassNames(s.root, className)} {...rest} />;
}

function Canvas({ className, ...rest }: InventoryCanvasProps) {
  return <main className={joinClassNames(s.canvas, className)} {...rest} />;
}

function Rail({ className, ...rest }: InventoryRailProps) {
  return <aside className={joinClassNames(s.rail, className)} {...rest} />;
}

export const InventoryCockpit = Object.assign(Root, {
  Canvas,
  Rail,
});
